/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { Stack } from '@fluentui/react/lib/Stack';
import { CustomizerContext } from '@fluentui/react/lib/Utilities';
import * as React from 'react';
import { resetCreateTemplateInstance } from '../../../apollo/reactiveVariables/TemplateInstanceVariables';
import { TemplateManagementHeader } from '../../components';
import { CreateTemplateInstanceCommandBar } from '../../components/CreateTemplateInstanceCommandBar';
import { CreateTemplateInstanceSideBar } from '../../components/CreateTemplateInstanceSidebar';
import { CreateTemplateInstanceWizard } from '../../components/CreateTemplateInstanceWizard/CreateTemplateInstanceWizard';
import { TemplateInstanceCancellationDialog } from '../../components/TemplateInstanceCancellationDialog';
import { TemplateManagementModal } from '../TemplateManagementModal';
import {
    getContentStackItemStyles,
    getInnerStackStyles,
    getSidebarStyles,
    getStackStyles,
} from './CreateTemplateInstance.styles';

export const CreateTemplateInstance: React.FC = (): JSX.Element => {
    const theme = React.useContext(CustomizerContext).customizations.settings.theme;

    React.useEffect((): (() => void) => {
        return (): void => {
            resetCreateTemplateInstance();
        };
    }, []);

    const createTemplateInstancePage = React.useMemo((): JSX.Element => {
        return (
            <>
                <Stack styles={getStackStyles(theme)}>
                    <Stack.Item>
                        <TemplateManagementHeader />
                    </Stack.Item>
                    <Stack.Item>
                        <CreateTemplateInstanceCommandBar />
                    </Stack.Item>
                    <Stack.Item styles={getContentStackItemStyles} grow>
                        <Stack horizontal styles={getInnerStackStyles}>
                            <Stack.Item styles={getSidebarStyles(theme)}>
                                <CreateTemplateInstanceSideBar />
                            </Stack.Item>
                            <Stack.Item grow>
                                <CreateTemplateInstanceWizard />
                            </Stack.Item>
                        </Stack>
                    </Stack.Item>
                </Stack>
                <TemplateInstanceCancellationDialog />
                <TemplateManagementModal />
            </>
        );
    }, [theme]);

    return <div>{createTemplateInstancePage}</div>;
};
